"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = void 0;

var _logger = _interopRequireDefault(require("./logger"));

var _constants = require("../constants");

var Bowser = require('bowser');

var get = function get(userAgent) {
  var _Bowser$getParser$get = Bowser.getParser(userAgent).getResult(),
      _Bowser$getParser$get2 = _Bowser$getParser$get.browser,
      browserName = _Bowser$getParser$get2.name,
      browserVersion = _Bowser$getParser$get2.version,
      _Bowser$getParser$get3 = _Bowser$getParser$get.os,
      osName = _Bowser$getParser$get3.name,
      osVersion = _Bowser$getParser$get3.version,
      platformType = _Bowser$getParser$get.platform.type;

  var platform;

  if (_constants.PLATFORM_WHITELIST.includes(platformType)) {
    // There must be a better way of re-typing to `Platform`, but I haven't found it:
    platform = platformType;
  } else {
    _logger["default"].error(new Error("Unknown device platform detected.  Expecting ".concat(_constants.PLATFORM_WHITELIST.join(' | '), ". Received instead ").concat(platformType, ". This was parse from the user agent: ").concat(userAgent, ".")));
  }

  return {
    browserName: browserName,
    browserVersion: browserVersion,
    osName: osName,
    osVersion: osVersion,
    platform: platform
  };
};

exports.get = get;